import React from 'react';
import Image from 'next/image';
// import Swiper core and required modules
import SwiperCore, { Autoplay, Lazy, Navigation, Pagination } from 'swiper';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Import Swiper styles
import 'swiper/css';

// install Swiper modules
SwiperCore.use([ Autoplay, Navigation, Pagination, Lazy ]);

import Checkers from '../../../../../helpers/class/Checkers';

function ModalServices ( props ) {
  const service = props.service
  const images = props.service.service_images
  return (
    <div className="modal-body">
      <div className="row">
        <div className="col-12">
          <Swiper
            speed={1000}
            navigation={true}
            pagination={true}
            slidesPerView={1}
            autoplay={false}
            className="cursor-pointer mb-3"
            style={{ height: 310 }}
          >
            {
              Checkers.serviceImagesValid( service ) &&
                            images.map( ( slide, index ) => (

                              <SwiperSlide key={slide.service_media_id.toString()}>
                                <Image
                                  priority={index == 0}
                                  // loading={key == 0 ? 'eager' : 'lazy'}
                                  data-src={slide.service_image}
                                  data-fancybox={'modal-service-' + service.service_id}
                                  data-caption={slide.service_image_caption}
                                  layout={'fill'}
                                  sizes={'50vw'}
                                  quality={'50'}
                                  src={slide.service_image}
                                  alt={'Slide-' + index}
                                  objectFit={'cover'}
                                  placeholder={'blur'}
                                  blurDataURL={'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='}
                                />
                              </SwiperSlide>
                            ) )
            }
          </Swiper>
          <div dangerouslySetInnerHTML={{ __html: props.service.service_body }}/>
        </div>
      </div>
    </div>
  )
}
export default ModalServices;
